<template>
    <div>
      <v-dialog v-model="archivoGrande" persistent>
        <v-card>
          <v-card-title>
            Archivo demasiado grande
          </v-card-title>
          <v-card-text>
            El archivo seleccionado es demasiado grande. Por favor seleccione un archivo más pequeño (1MB de tamaño).
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="archivoGrande = false">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        archivoAdjunto: null,
        previsualizacion: false,
        archivoGrande: false,
      };
    },
    methods: {
      abrir(esGrande) {
        this.archivoGrande = esGrande
      }
    }
  };
  </script>